/**
 * OnlyPlanks Trade Unlock — ABN gate (phase 2 / abr_active)
 * body.op-trade-pdp / /products/trade-unlock
 * Client checksum + Worker ABR Active required before ATC.
 * properties[ABN] digits-only.
 */
(function () {
  'use strict';

  var WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  var API =
    (typeof window !== 'undefined' && window.OP_ABN_VERIFY_API) ||
    'https://onlyplanks-abn-verify.richard-b94.workers.dev';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function digitsOnly(s) {
    return String(s || '').replace(/\D/g, '');
  }

  function formatAbnDisplay(digits) {
    var d = digitsOnly(digits).slice(0, 11);
    if (d.length <= 2) return d;
    if (d.length <= 5) return d.slice(0, 2) + ' ' + d.slice(2);
    if (d.length <= 8) return d.slice(0, 2) + ' ' + d.slice(2, 5) + ' ' + d.slice(5);
    return d.slice(0, 2) + ' ' + d.slice(2, 5) + ' ' + d.slice(5, 8) + ' ' + d.slice(8);
  }

  function isValidAbnChecksum(abn) {
    var d = digitsOnly(abn);
    if (d.length !== 11) return false;
    var nums = d.split('').map(function (c) {
      return parseInt(c, 10);
    });
    nums[0] -= 1;
    var sum = 0;
    for (var i = 0; i < 11; i++) sum += nums[i] * WEIGHTS[i];
    return sum % 89 === 0;
  }

  function isTradePdp() {
    var b = document.body;
    if (!b) return false;
    if (b.classList.contains('op-trade-pdp')) return true;
    if (/\btemplate-product-trade-unlock\b/.test(b.className || '')) return true;
    var path = (location.pathname || '').replace(/\/+$/, '');
    return path === '/products/trade-unlock';
  }

  function findProductForm() {
    return (
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form-component form.shopify-product-form') ||
      document.querySelector('form.shopify-product-form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function findAtcButtons() {
    var list = [];
    document
      .querySelectorAll(
        'button[type="submit"].add-to-cart-button, .add-to-cart-button, sticky-add-to-cart button.add-to-cart-button, [data-testid="standalone-add-to-cart"]'
      )
      .forEach(function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    return list;
  }

  function ensureFormProperty(form, value) {
    if (!form) return null;
    var input = form.querySelector('input[name="properties[ABN]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[ABN]';
      form.appendChild(input);
    }
    input.value = value || '';
    return input;
  }

  function setButtonsEnabled(enabled) {
    findAtcButtons().forEach(function (btn) {
      if (enabled) {
        btn.removeAttribute('disabled');
        btn.classList.remove('op-abn-blocked');
        btn.setAttribute('aria-disabled', 'false');
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('op-abn-blocked');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function setStatus(el, kind, text) {
    if (!el) return;
    el.textContent = text || '';
    el.className = 'op-abn-status' + (kind ? ' op-abn-status--' + kind : '');
    el.hidden = !text;
  }

  function pickMount() {
    var form = findProductForm();
    var soft = document.querySelector('.op-abn-field');
    if (form) {
      var mount = document.createElement('div');
      mount.className = 'op-abn-field';
      mount.id = 'op-abn-wrap';
      var buttons =
        form.querySelector('.product-form-buttons') ||
        form.querySelector('[ref="productFormButtons"]');
      if (buttons && buttons.parentNode) {
        buttons.parentNode.insertBefore(mount, buttons);
      } else {
        form.appendChild(mount);
      }
      if (soft && soft !== mount) {
        soft.classList.add('op-abn-field--legacy');
        soft.innerHTML =
          '<p class="hint">Enter your ABN in the field above the Unlock button.</p>';
      }
      return mount;
    }
    if (soft) return soft;
    var host =
      document.querySelector('.product-details') ||
      document.querySelector('.product-information') ||
      document.querySelector('main');
    var fallback = document.createElement('div');
    fallback.className = 'op-abn-field';
    fallback.id = 'op-abn-wrap';
    if (host) host.appendChild(fallback);
    return fallback;
  }

  var verifyTimer = null;
  var lastVerified = '';
  var abrActiveOk = false;
  var abrActiveDigits = '';

  function gateOpen(digits) {
    return abrActiveOk && abrActiveDigits === digits && isValidAbnChecksum(digits);
  }

  function clearAbrGate() {
    abrActiveOk = false;
    abrActiveDigits = '';
    lastVerified = '';
  }

  function callVerify(digits, statusEl, form, wrap) {
    if (!API) {
      setStatus(statusEl, 'err', 'ABN check unavailable — try again shortly');
      setButtonsEnabled(false);
      ensureFormProperty(form, '');
      return;
    }
    if (lastVerified === digits && gateOpen(digits)) {
      setButtonsEnabled(true);
      return;
    }
    setStatus(statusEl, 'pending', 'Checking ABR…');
    setButtonsEnabled(false);
    fetch(String(API).replace(/\/$/, '') + '/v1/abn-verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ abn: digits }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { okHttp: r.ok, data: data };
        });
      })
      .then(function (res) {
        var data = res.data || {};
        var statusLower = String(data.status || '').toLowerCase();
        if (data.ok && statusLower === 'active') {
          lastVerified = digits;
          abrActiveOk = true;
          abrActiveDigits = digits;
          wrap.classList.add('op-abn-field--valid');
          wrap.classList.remove('op-abn-field--invalid');
          ensureFormProperty(form, digits);
          setButtonsEnabled(true);
          if (data.entityName) {
            setStatus(statusEl, 'ok', 'Active: ' + data.entityName);
          } else {
            setStatus(statusEl, 'ok', 'Active on the ABR');
          }
          return;
        }
        clearAbrGate();
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        if (data.error === 'abn_not_active') {
          setStatus(statusEl, 'err', 'ABN is not Active on the ABR');
        } else if (data.error === 'checksum_invalid') {
          setStatus(statusEl, 'err', 'That ABN does not pass the checksum check');
        } else if (data.error === 'abr_lookup_failed') {
          setStatus(statusEl, 'err', 'ABR check failed — try again shortly');
        } else {
          setStatus(
            statusEl,
            'err',
            data.message || 'Could not confirm Active status — try again'
          );
        }
      })
      .catch(function () {
        clearAbrGate();
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        setStatus(statusEl, 'err', 'ABN check unavailable — try again shortly');
      });
  }

  function buildField(wrap) {
    wrap.innerHTML = '';
    var label = document.createElement('label');
    label.setAttribute('for', 'op-abn-input');
    label.innerHTML = 'Australian Business Number (ABN) <span aria-hidden="true">*</span>';

    var input = document.createElement('input');
    input.id = 'op-abn-input';
    input.type = 'text';
    input.setAttribute('autocomplete', 'organization');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('placeholder', 'XX XXX XXX XXX');
    input.setAttribute('maxlength', '14');
    input.setAttribute('aria-required', 'true');
    input.setAttribute('aria-describedby', 'op-abn-hint op-abn-status');

    var hint = document.createElement('p');
    hint.className = 'hint';
    hint.id = 'op-abn-hint';
    hint.textContent =
      'Required for Trade eligibility and warehouse pricing. Enter your 11-digit ABN (spaces ok). Must be Active on the ABR. Stored as line item property ABN (digits only).';

    var status = document.createElement('p');
    status.className = 'op-abn-status';
    status.id = 'op-abn-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;

    wrap.appendChild(label);
    wrap.appendChild(input);
    wrap.appendChild(hint);
    wrap.appendChild(status);

    var form = findProductForm();
    ensureFormProperty(form, '');

    function sync() {
      var digits = digitsOnly(input.value);
      var display = formatAbnDisplay(digits);
      if (input.value !== display) input.value = display;
      var valid = isValidAbnChecksum(digits);
      wrap.classList.toggle('op-abn-field--valid', gateOpen(digits));
      wrap.classList.toggle('op-abn-field--invalid', digits.length === 11 && !valid);
      if (!digits) {
        clearAbrGate();
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        setStatus(status, '', '');
      } else if (digits.length < 11) {
        clearAbrGate();
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        setStatus(status, 'pending', 'Enter all 11 digits');
      } else if (!valid) {
        clearAbrGate();
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        setStatus(status, 'err', 'That ABN does not pass the checksum check');
      } else if (gateOpen(digits)) {
        ensureFormProperty(form, digits);
        setButtonsEnabled(true);
      } else {
        ensureFormProperty(form, '');
        setButtonsEnabled(false);
        setStatus(status, 'pending', 'Checking ABR…');
        if (verifyTimer) clearTimeout(verifyTimer);
        verifyTimer = setTimeout(function () {
          callVerify(digits, status, form, wrap);
        }, 400);
      }
      return gateOpen(digits);
    }

    input.addEventListener('input', sync);
    input.addEventListener('blur', sync);
    input.addEventListener('change', sync);
    setButtonsEnabled(false);
    sync();

    return {
      input: input,
      status: status,
      sync: sync,
      getDigits: function () {
        return digitsOnly(input.value);
      },
      isGateOpen: function () {
        return gateOpen(digitsOnly(input.value));
      },
    };
  }

  function intercept(fieldApi) {
    var form = findProductForm();
    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          var digits = fieldApi.getDigits();
          if (!fieldApi.isGateOpen()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            fieldApi.sync();
            fieldApi.input.focus();
            return false;
          }
          ensureFormProperty(form, digits);
        },
        true
      );
    }

    document.addEventListener(
      'click',
      function (e) {
        if (!isTradePdp()) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var btn = t.closest(
          '.add-to-cart-button, button[type="submit"].add-to-cart-button, [data-testid="standalone-add-to-cart"]'
        );
        if (!btn) return;
        var digits = fieldApi.getDigits();
        if (!fieldApi.isGateOpen()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          fieldApi.sync();
          fieldApi.input.focus();
          return false;
        }
        ensureFormProperty(findProductForm(), digits);
      },
      true
    );

    var mo = new MutationObserver(function () {
      setButtonsEnabled(fieldApi.isGateOpen());
    });
    findAtcButtons().forEach(function (btn) {
      mo.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    });
  }

  function updateCopy() {
    document.querySelectorAll('.op-trade-copy p, .op-trade-copy li').forEach(function (el) {
      var html = el.innerHTML;
      if (!html) return;
      var next = html
        .replace(/\u2014/g, ' - ')
        .replace(/—/g, ' - ')
        .replace(/put it in the cart note before checkout/gi, 'enter it in the ABN field before you unlock')
        .replace(/add your ABN in the cart note before checkout/gi, 'enter your ABN in the field before you unlock');
      if (next !== html) el.innerHTML = next;
    });
  }

  ready(function () {
    if (!isTradePdp()) return;
    updateCopy();
    var wrap = pickMount();
    if (!wrap) return;
    var fieldApi = buildField(wrap);
    intercept(fieldApi);
  });
})();
